// removed by extract-text-webpack-plugin
module.exports = {"security":"src-pages-security-style----general-module---security---3I3u7","wrapper":"src-pages-security-style----general-module---wrapper---1zaVb breakPointM-alignContent-stretch centered display-flex breakPointM-display-flex width-90","rightcol":"src-pages-security-style----general-module---rightcol---1swv0 flex-1","leftcol":"src-pages-security-style----general-module---leftcol---fNHk0"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/security/style/general.module.css
// module id = 1505
// module chunks = 3627797113349